<script lang="ts">
    import Component, { mixins } from 'vue-class-component'; 
    import { strCompareLowerCase } from '@common/Common';
    import UsersQueries from '@Organizations/Users/Domain/queries-vue-component';
    import { UserSessionDetailsReadModel, WorkspaceItem } from '@Organizations/Users/Domain/readmodels';

    @Component({
        props: {
            workspaceId: {
                type: Number,
                required: true,
            },
            workspaceName: {
                type: String | null,
                required: true,
                default: "Workspace"
            }
        }
    })
    export default class WorkspaceNavigation extends mixins(UsersQueries)
    {
        user: UserSessionDetailsReadModel = null;

        get workspacesView(): unknown[]
        {
            if (!this.user?.Workspaces.length)
            {
                return [];
            }

            const workspaceGroups = new Map<string, WorkspaceItem[]>();

            for (const workspace of this.user.Workspaces)
            {
                const orgName = workspace.OrganizationName;

                if (!workspaceGroups.has(orgName))
                {
                    workspaceGroups.set(orgName, []);
                }

                workspaceGroups.get(orgName).push(workspace);
            }

            return Array.from(workspaceGroups).map(([org, workspaces]) => ({
                OrganizationUnitName: org,
                Workspaces: workspaces.sort((a, b) => strCompareLowerCase(a.Name, b.Name)),
            }))
                .sort((a, b) => strCompareLowerCase(a.OrganizationUnitName, b.OrganizationUnitName));
        };

        loadUser()
        {
            if (this.user == null)
            {
                this.runCurrentUserQueryV1(false, false, false);
            }
        }

        onSetModel(model: any, modelName: string)
        {
            if (modelName == "UserSessionDetailsReadModel")
            {
                const rm = model as UserSessionDetailsReadModel;
                this.user = rm;
            }
        }
    }

</script>

<template>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#WorkspaceNavigation" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="WorkspaceNavigation">

            <ul class="navbar-nav mr-auto">
                <li class="nav-item dropdown">
                    <a class="navbar-brand dropdown-toggle text-light" @click="loadUser()" id="navbarDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span>{{workspaceName}}</span>
                    </a>
                    <div class="dropdown-menu" style="max-height: 400px; overflow-y: auto;">
                        <div v-if="user">
                            <div v-for="g in workspacesView">
                                <h6 class="dropdown-header">
                                    <i class="fa fa-home" aria-hidden="true"></i>
                                    <span>{{g.OrganizationUnitName}}</span>
                                </h6>
                                <a class="dropdown-item" v-for="w in g.Workspaces" :key="w.Id" v-sanitizedHref="`/#/dashboard/${w.Id}`">
                                    <strong>{{w.Name}}</strong>
                                </a>
                                <div class="dropdown-divider"></div>
                            </div>
                        </div>
                        <div v-else>
                            Loading
                        </div>
                    </div>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/scales/${workspaceId}`">Scales</a>
                </li>
            </ul>

            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a @click="loadUser" class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span>Account</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
                        <div v-if="user">
                            <a v-if="user.IsGlobalAdmin || user.IsOrganizationAdmin" class="dropdown-item" v-sanitizedHref="`/#/admin/organizations/dashboard/${user.OrganizationUnitId}`">
                                Go to admin
                            </a>
                            <a class="dropdown-item" href="/#/organizations/users/dashboard">My dashboard</a>
                            <a class="dropdown-item" v-sanitizedHref="`/#/organizations/users/account`">Manage your account</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" v-sanitizedHref="`/organizations/sessions/close`">Sign out</a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<style scoped>
    .navbar {
        -webkit-box-shadow: 0 2px 6px 0 #999;
        -moz-box-shadow: 0 2px 6px 0 #999;
        box-shadow: 0 2px 6px 0 #999;
    }
</style>